export interface BoldMarkdownSegment {
  text: string;
  bold: boolean;
}

/**
 * The assistant intentionally supports one small Markdown subset. Everything
 * else stays text so model output cannot create links, headings, or HTML.
 */
export function parseBoldMarkdown(source: string): BoldMarkdownSegment[] {
  const segments: BoldMarkdownSegment[] = [];
  const pattern = /\*\*([^*\n]+)\*\*/gu;
  let cursor = 0;

  for (const match of source.matchAll(pattern)) {
    const index = match.index ?? 0;
    if (index > cursor) segments.push({ text: source.slice(cursor, index), bold: false });
    segments.push({ text: match[1], bold: true });
    cursor = index + match[0].length;
  }

  if (cursor < source.length) segments.push({ text: source.slice(cursor), bold: false });
  return segments.length > 0 ? segments : [{ text: source, bold: false }];
}

export function hasUnsupportedMarkdown(source: string): boolean {
  return /(^|\n)\s*(?:#{1,6}\s|[-*+]\s|\d+\.\s)|```|\[[^\]]+\]\([^)]*\)|`[^`]+`|(?<!\*)\*[^*\n]+\*(?!\*)|_{1,2}[^_\n]+_{1,2}/u.test(source);
}
